import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import TopMenu from '../../../../Components/TopMenu/TopMenu';
import Export from "../../../../assets/images/export.svg";
import Exportw from "../../../../assets/images/exportw.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

import UCM from './UCM';
import LUC from './LUC';
import SCM from './SCM';
import MessageLog from './MessageLog';

import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { withRFSToken } from '../../../../Services/axios.js';
import { ULDSEARCH, ULDSEARCHDETAILS } from '../../../../Utils/conts.js';

const History = () => {
    const initialTab = ['ucm', 'luc', 'scm', 'msg_log'].includes(localStorage.getItem("Htab")) ? localStorage.getItem("Htab") : 'ucm';
    const [selectedButton, setSelectedButton] = useState(initialTab);
    useEffect(() => {
        setSelectedButton(initialTab);
    }, [initialTab]);
    const handleButtonClick = (button) => {
        setSelectedButton(button);
        localStorage.setItem('Htab', button);
    };

    const isMounted = useRef(false);
    const [searchItems, setSearchItems] = useState([])
    const fetchDataGrid = async () => {
        try {
            const res = await withRFSToken.post(ULDSEARCH, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData.map((name, index) => ({
                        id: index,
                        name: name
                    }));
                    setSearchItems(transformedData);

                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        fetchDataGrid();
        isMounted.current = true;
    }, []);

    const handleOnSearch = (string, results) => {
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        console.log(string, results)
    }

    const handleOnHover = (result) => {
        // the item hovered
        console.log(result)
    }

    const handleOnSelect = async (item) => {
        // the item selected
        console.log(item)
        try {
            const res = await withRFSToken.post(ULDSEARCHDETAILS, { uld_number: item.name });
            if (res.data.response_code == 200) {
                localStorage.removeItem('MHistory');
                const storageData = {
                    ULD: res.data.response_data,  // ULD Details section
                    Form: {}  // Empty form section
                };
                localStorage.setItem('MHistory', JSON.stringify(storageData));
                localStorage.setItem('Htab', initialTab);
                window.location.href = '/ULDControl/MovementHistory'
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const handleOnFocus = () => {
        // console.log('Focused')
    }
    return (
        <>
            <div className="">
                <Header logo_url='/ULDControl' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='ULD' />
                            <div className="">
                                <div className="allcontent-fl">
                                    <div className='d-flex justify-content-between mb-3'>
                                        <div>
                                            <button className={selectedButton === 'ucm' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('ucm')}>
                                                <img src={selectedButton === 'ucm' ? Exportw : Export} /> <span>UCM</span>
                                            </button>
                                            <button className={selectedButton === 'luc' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('luc')}>
                                                <img src={selectedButton === 'luc' ? Exportw : Export} /> <span>LUC</span>
                                            </button>
                                            <button className={selectedButton === 'scm' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('scm')}>
                                                <img src={selectedButton === 'scm' ? Exportw : Export} /> <span>SCM</span>
                                            </button>
                                            <button className={selectedButton === 'msg_log' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('msg_log')}>
                                                <img src={selectedButton === 'msg_log' ? Exportw : Export} /> <span>Message Log</span>
                                            </button>
                                        </div>
                                        <div className='search'>
                                            <div className="form-group has-search">
                                                {/* <span className="form-control-feedback"> <FontAwesomeIcon icon={faMagnifyingGlass} /></span> */}
                                                {/* <input type="text" className="form-control" placeholder="Search ULD" /> */}
                                                <ReactSearchAutocomplete
                                                    items={searchItems}
                                                    onSearch={handleOnSearch}
                                                    onHover={handleOnHover}
                                                    onSelect={handleOnSelect}
                                                    onFocus={handleOnFocus}
                                                    autoFocus
                                                    placeholder="Search ULD"
                                                // formatResult={formatResult}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="lcontent">
                                        {selectedButton === 'ucm' &&
                                            <UCM />
                                        }
                                        {selectedButton === 'luc' &&
                                            <LUC />
                                        }
                                        {selectedButton === 'scm' &&
                                            <SCM />
                                        }
                                        {selectedButton === 'msg_log' &&
                                            <MessageLog />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default History